import {useHttp, resetSessionExpired} from '@/core/http'
import {useAuth} from '@/plugins/auth'
import {useToken} from '@/core/utils/token'

const tokenHelper = useToken()

export const useAuthService = () => {

    const login = <T>(payload: any): Promise<T> => {
        return new Promise<T>((resolve, reject) => {
            useHttp()
                .post('/v2/auth/login', payload)
                .then((data: any) => {
                    tokenHelper.setToken(data)
                    resetSessionExpired()
                    useAuth().auth()
                        .then(() => {
                            resolve(data as T)
                        })
                        .catch((response) => {
                            tokenHelper.clearToken()
                            reject(response as T)
                        })
                })
                .catch((response: any) => {
                    tokenHelper.clearToken()
                    reject(response as T)
                })
        })
    }

    const logout = (): boolean => {
        let status = false

        useHttp().post('auth/logout')
            .finally(() => {
                status = tokenHelper.clearToken()
            })

        return status
    }

    const getUser = <T>(): Promise<T> => {
        return new Promise<T>((resolve, reject) => {
            useHttp()
                .get('auth/user')
                .then((data: any) => {
                    resolve(data as T)
                })
                .catch((response: any) => {
                    tokenHelper.clearToken()
                    reject(response as T)
                })
        })
    }

    const changePassword = <T>(payload: any): Promise<T> => {
        return useHttp().post('auth/change-password', payload)
    }

    return {
        login,
        getUser,
        logout,
        changePassword,
    }
}
